import { render, staticRenderFns } from "./DocumentsRelated.vue?vue&type=template&id=7212cd44&scoped=true"
import script from "./DocumentsRelated.vue?vue&type=script&lang=js"
export * from "./DocumentsRelated.vue?vue&type=script&lang=js"
import style0 from "./DocumentsRelated.vue?vue&type=style&index=0&id=7212cd44&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7212cd44",
  null
  
)

export default component.exports